<div class="care-plan-container">
  <div class="back-align">
    <i class="fas fa-chevron-left back-btn" (click)="goBack()"></i>
    <h2 class="track">Track and personalize your health goals and nutrition targets</h2>
  </div>
  
  <p class="subtitle">Personalized care plan</p>

  <section class="goals">
    <div class="header">
      <h3> <img src="assets/images/target.png"/>My Goals</h3>
    </div>
    
    <div *ngFor="let goal of goals;let i = index" class="goal-card">
  <div class="goal-title">
    <div class="goal-header">
      <span class="goal-id-circle">{{ i+1 }}</span>
      <span class="goal-type">{{ goal.goalType }}</span>
    </div>
    <!-- <div class="icons">
      <i class="fas fa-pen edit-icon" (click)="openEditGoalDialog(goal)"></i>
      <button class="delete-btn" >🗑️</button>
    </div> -->
  </div>

  <div class="goal-details">
    <p *ngIf="goal.targetText"> {{ goal.targetText }}</p>

    <p *ngIf="goal.targetValue && goal.targetValue !== '0.00'">
      <strong>Target Value:</strong> {{ goal.targetValue }}
    </p>
    <p *ngIf="goal.presentValue && goal.presentValue !== '0.00'">
      <strong>Current Value:</strong> {{ goal.presentValue }}
    </p>

    <progress
      *ngIf="isNumeric(goal.presentValue) && isNumeric(goal.targetValue) && +goal.targetValue > 0"
      [value]="goal.presentValue"
      [max]="goal.targetValue"
    ></progress>
  </div>
</div>

  </section>

  <section class="nutrition">
    <div class="header">
     <h3><img src="assets/images/nutrition.png"/>Nutrition Plan</h3>
    <div class="add-btn">
      <button class="add-new-btn" mat-raised-button (click)="openAddGoalDialog()">
        <i class="fas fa-pen edit-icon" style="color: white;"></i> &nbsp; <span class="btn-text">Entry Details</span>
    </button>
    </div>
    </div>
    
    <div class="nutrition-grid">
  <div
    class="nutrition-card"
    *ngFor="let item of nutrition; index as i"
    [ngClass]="getCardClass(item)"
  >
    <div class="nut-icons">
      <img [src]="'assets/images/' + item.title.toLowerCase() + '.png'" />
      
      <!-- <i class="fas fa-pen edit-icon"></i> -->
    </div>

    <p class="nut-title">{{ item.title }}</p>
    <p class="nut-quantity">{{ item.qty }} {{ item.unit }}</p>
    <p class="nut-quantity-row">
      <span class="progress-value">{{getDietQuantity(item)}}</span>
      <span class="progress-value">{{getProgress(item)}}%</span>
    </p>

    <progress [value]="getProgress(item)" [max]="100" ></progress>
  </div>
</div>

  </section>
</div>
